/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_LeadInputs */

const en_us2_gyms_lead = /** @type {(inputs: Gyms_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save the equipment of each place you train and switch in one tap. The plan always uses the gym in effect.`)
};

const pt_br2_gyms_lead = /** @type {(inputs: Gyms_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salve os equipamentos de cada lugar onde você treina e troque com um toque. O plano sempre usa a academia em uso.`)
};

const es_419_gyms_lead = /** @type {(inputs: Gyms_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guarda el equipo de cada lugar donde entrenas y cambia con un toque. El plan siempre usa el gimnasio en uso.`)
};

const pt_pt2_gyms_lead = /** @type {(inputs: Gyms_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guarda o equipamento de cada sítio onde treinas e troca com um toque. O plano usa sempre o ginásio em uso.`)
};

const fr_fr2_gyms_lead = /** @type {(inputs: Gyms_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistre l'équipement de chaque lieu où tu t'entraînes et change en un geste. Le programme utilise toujours la salle active.`)
};

const de_de2_gyms_lead = /** @type {(inputs: Gyms_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichere die Ausstattung jedes Orts, an dem du trainierst, und wechsle mit einem Tipp. Der Plan nutzt immer das aktive Studio.`)
};

const it_it2_gyms_lead = /** @type {(inputs: Gyms_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva l'attrezzatura di ogni posto in cui ti alleni e cambia con un tocco. La scheda usa sempre la palestra in uso.`)
};

/**
* | output |
* | --- |
* | "Save the equipment of each place you train and switch in one tap. The plan always uses the gym in effect." |
*
* @param {Gyms_LeadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_lead = /** @type {((inputs?: Gyms_LeadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_LeadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_lead(inputs)
	if (locale === "es-419") return es_419_gyms_lead(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_lead(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_lead(inputs)
	if (locale === "de-DE") return de_de2_gyms_lead(inputs)
	if (locale === "it-IT") return it_it2_gyms_lead(inputs)
	return en_us2_gyms_lead(inputs)
});
export { gyms_lead as "gyms.lead" }